import noop from 'lodash/noop';
import React from 'react';
import { useFirstMountState } from 'react-use';
import Pagination from '../../Misc/Pagination/Pagination';
import Filters from '../Filters/Filters';
import FiltersMobile from '../FiltersMobile/FiltersMobile';
import SideFilter from '../SideFilter/SideFilter';
import S from './FilteredListing.styles';
function FilteredListing({ complete, error, errorText, filtersProps, items, pageSize = 9, sideFilterProps, listTitle, pageIndex = 0, renderItems, totalItems = 0, hideUserFilters = false, onReset, onPageChange = noop, }) {
    const [sideFilterOpen, setSideFilterOpen] = React.useState(false);
    const isFirstMount = useFirstMountState();
    const refItemList = React.useRef(null);
    React.useEffect(() => {
        if (isFirstMount) {
            return;
        }
        if (complete === true || pageIndex) {
            refItemList.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'start',
            });
        }
    }, [complete, pageIndex]);
    return (React.createElement(S.Container, { ref: refItemList },
        React.createElement(S.Inner, null,
            sideFilterProps && (React.createElement(S.SideFilter, null, !hideUserFilters && sideFilterProps && (React.createElement(SideFilter, { ...sideFilterProps, sideFilterOpen: sideFilterOpen, setSideFilterOpen: setSideFilterOpen, onReset: onReset })))),
            React.createElement(S.Main, { "data-has-side-nav": !hideUserFilters && sideFilterProps ? true : false },
                listTitle && React.createElement(S.ListTitle, null, listTitle),
                filtersProps && (React.createElement(Filters, { ...filtersProps, totalItems: totalItems, pageIndex: pageIndex, itemAmount: items?.length, pageSize: pageSize })),
                filtersProps && (React.createElement(FiltersMobile, { ...filtersProps, totalItems: totalItems, pageIndex: pageIndex, itemAmount: items?.length, setSideFilterOpen: setSideFilterOpen, hasSideFilter: !hideUserFilters && sideFilterProps ? true : false })),
                error && renderError(error),
                items && items.length ? renderResults(items ?? []) : null))));
    function renderError(error) {
        return React.createElement(S.Message, null, error.message);
    }
    function renderResults(items) {
        if (items.length === 0) {
            return React.createElement(S.Message, null, errorText);
        }
        return (React.createElement(React.Fragment, null,
            renderItems(items),
            items.length < totalItems && (React.createElement(Pagination, { pageIndex: pageIndex, pageSize: pageSize, onPageChange: onPageChange, totalCount: totalItems }))));
    }
}
export default FilteredListing;
